/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-04-28 10:06:33
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-04-28 11:02:28
 * @FilePath: \ns-web-evaluation\pc\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import NS from '@ns/ui'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
// import microApp from '@micro-zoe/micro-app'
import VXETable from 'vxe-table'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { setupGlobalLinkConfirm } from '@/hooks/useGlobalLinkConfirm'
import { http } from '@/utils/http'
import { setupI18n } from '@/locales/index'
import NsEmpty from '@/components/NsEmpty'
import 'formdata-polyfill'
import { setupStore } from './store'
import { setupRouter } from './router'
import { setUpEHome } from './ehome'
import '@ns/ui/dist/es/style.less'
import App from './App.vue'

import 'vxe-table/lib/style.css'
// import '@unocss/reset/tailwind-compat.css'
import '@/styles/index.less'
import 'virtual:svg-icons-register'
import 'uno.css'

// import 'ant-design-vue/dist/reset.css'
// 动态导入 VConsole,避免打包到生产环境
if (import.meta.env.MODE === 'dev') {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole()
  })
}
setupGlobalLinkConfirm()
NS.setup({
  http
})

// microApp.start()
// VxeTable.use(VXETablePluginAntd)
// VxeTable.use(VXETablePluginRenderer)
export async function bootstrap() {
  const { isPlatform } = getAppEnvConfig()
  const app = createApp(App)
  if (!isPlatform) {
    await setUpEHome()
  }
  await setupI18n(app)
  setupRouter(app)
  setupStore(app)
  app.use(VXETable)
  app.use(NS)
  app.use(autoAnimatePlugin)
  app.component('NsEmpty', NsEmpty)
  app.use(VueDOMPurifyHTML)
  app.mount('#app')
}

bootstrap()
